/**
 * Created by Ning Jiang on 2022-10-29.
 */
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Serial} from "../../Serial";
import {gsap} from "gsap";
import {WinCapClock} from "./WinCapClock";

export class WinCapText extends PIXI.Container {

    private _topLeftStyle:PIXI.TextStyle = new PIXI.TextStyle({
        align : "left",
        breakWords : false,
        dropShadow : true,
        dropShadowBlur : 2,
        dropShadowColor : "#000000",
        dropShadowDistance : 2,
        fill : "#aaaaaa",
        fontFamily : "VCR OSD Mono",
        fontSize : 30,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.NORMAL,
        lineHeight : 36
    });

    private _topRightStyle:PIXI.TextStyle = new PIXI.TextStyle({
        align : "right",
        breakWords : false,
        dropShadow : true,
        dropShadowBlur : 2,
        dropShadowColor : "#000000",
        dropShadowDistance : 2,
        fill : "#aaaaaa",
        fontFamily : "VCR OSD Mono",
        fontSize : 30,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.NORMAL,
        lineHeight : 36
    });

    private _bottomLeftStyle1:PIXI.TextStyle = new PIXI.TextStyle({
        align : "left",
        breakWords : false,
        dropShadow : true,
        dropShadowBlur : 2,
        dropShadowColor : "#000000",
        dropShadowDistance : 2,
        fill : "#aaaaaa",
        fontFamily : "VCR OSD Mono",
        fontSize : 18,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.NORMAL,
        lineHeight : 20
    });

    private _bottomLeftStyle2:PIXI.TextStyle = new PIXI.TextStyle({
        align : "left",
        breakWords : false,
        dropShadow : true,
        dropShadowBlur : 2,
        dropShadowColor : "#000000",
        dropShadowDistance : 2,
        fill : "#aaaaaa",
        fontFamily : "VCR OSD Mono",
        fontSize : 24,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.NORMAL,
        lineHeight : 26
    });

    private _selectionStyle:PIXI.TextStyle = new PIXI.TextStyle({
        align : "center",
        breakWords : false,
        dropShadow : true,
        dropShadowBlur : 2,
        dropShadowColor : "#000000",
        dropShadowDistance : 2,
        fill : "#aaaaaa",
        fontFamily : "VCR OSD Mono",
        fontSize : 26,
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.NORMAL,
        lineHeight : 28
    });

    private _topLeft:PIXI.Text | null;
    private _topRight:PIXI.Text | null;
    private _time:PIXI.Text | null;
    private _clock:WinCapClock | null;
    private _bottomLeft1:PIXI.Text | null;
    private _bottomLeft2:PIXI.Text | null;
    private _selection:PIXI.Text | null;
    private _blood:PIXI.Sprite | null;

    private _recDot:PIXI.Sprite | null;
    private _recTween:TweenMax | null;

    private _triangle1:PIXI.Sprite | null;
    private _triTween1:TweenMax | null;

    private _triangle2:PIXI.Sprite | null;
    private _triTween2:TweenMax | null;

    constructor() {
        super();
    }

    public start(restartTimer:boolean):void {
        if(!this._topLeft) {
            this._topLeft = new PIXI.Text("CH2\nPLAY", this._topLeftStyle);
            this._topLeft.position.set(90, 120);
            this.addChild(this._topLeft);
        }
        if(!this._topRight) {
            this._topRight = new PIXI.Text("TAPE\nREC", this._topRightStyle);
            this._topRight.anchor.set(1, 0);
            this._topRight.position.set(644, 120);
            this.addChild(this._topRight);
        }
        if(!this._time) {
            this._time = new PIXI.Text("0:00:00", this._topRightStyle);
            this._time.anchor.set(1, 0);
            this._time.position.set(644, 192);
            this.addChild(this._time);
        }
        if(!this._clock) {
            this._clock = new WinCapClock(this._time);
            this._clock.start();
        } else if(restartTimer) {
            this._clock!.start();
        }
        if(!this._bottomLeft1) {
            this._bottomLeft1 = new PIXI.Text("LP\nDST", this._bottomLeftStyle1);
            this._bottomLeft1.position.set(90, 480);
            this.addChild(this._bottomLeft1);
        }
        if(!this._bottomLeft2) {
            this._bottomLeft2 = new PIXI.Text("TV\nSRC", this._bottomLeftStyle2);
            this._bottomLeft2.position.set(90, 530);
            this.addChild(this._bottomLeft2);
        }
        if(!this._recDot) {
            this._recDot = new PIXI.Sprite(Serial.assetLoader.getTextures("wincap/red_dot")[0]);
            this._recDot.anchor.set(0.5);
            this._recDot.position.set(574, 170);
            this.addChild(this._recDot);
            this._recTween = gsap.to(this._recDot, {duration : 0.5, alpha : 0, yoyo : true, repeat : -1});
        }
        if(!this._triangle1) {
            this._triangle1 = new PIXI.Sprite(Serial.assetLoader.getTextures("wincap/triangle")[0]);
            this._triangle1.anchor.set(0.5);
            this._triangle1.scale.set(-0.8, 0.8);
            this._triangle1.position.set(116, 488);
            this.addChild(this._triangle1);
            this._triTween1 = gsap.to(this._triangle1, {duration : 0.5, alpha : 0, yoyo : true, repeat : -1});
        }
        if(!this._triangle2) {
            this._triangle2 = new PIXI.Sprite(Serial.assetLoader.getTextures("wincap/triangle")[0]);
            this._triangle2.anchor.set(0.5);
            this._triangle2.position.set(126, 540);
            this.addChild(this._triangle2);
            this._triTween2 = gsap.to(this._triangle2, {duration : 0.5, alpha : 0, yoyo : true, repeat : -1});
        }
    }

    public remove():void {
        if(this._topLeft) {
            this.removeChild(this._topLeft);
            this._topLeft.destroy();
            this._topLeft = null;
        }
        if(this._topRight) {
            this.removeChild(this._topRight);
            this._topRight.destroy();
            this._topRight = null;
        }
        if(this._time) {
            this._clock!.stop();
            this._clock = null;
            this.removeChild(this._time);
            this._time.destroy();
            this._time = null;
        }
        if(this._bottomLeft1) {
            this.removeChild(this._bottomLeft1);
            this._bottomLeft1.destroy();
            this._bottomLeft1 = null;
        }
        if(this._bottomLeft2) {
            this.removeChild(this._bottomLeft2);
            this._bottomLeft2.destroy();
            this._bottomLeft2 = null;
        }
        if(this._blood) {
            this.removeChild(this._blood);
            this._blood.destroy();
            this._blood = null;
        }
        if(this._selection) {
            this.removeChild(this._selection);
            this._selection.destroy();
            this._selection = null;
        }
        if(this._recDot) {
            if(this._recTween) {
                this._recTween.kill();
                this._recTween = null;
            }
            this.removeChild(this._recDot);
            this._recDot.destroy();
            this._recDot = null;
        }
        if(this._triangle1) {
            if(this._triTween1) {
                this._triTween1.kill();
                this._triTween1 = null;
            }
            this.removeChild(this._triangle1);
            this._triangle1.destroy();
            this._triangle1 = null;
        }
        if(this._triangle2) {
            if(this._triTween2) {
                this._triTween2.kill();
                this._triTween2 = null;
            }
            this.removeChild(this._triangle2);
            this._triangle2.destroy();
            this._triangle2 = null;
        }
    }

    public showSelection():void {
        if(!this._selection) {
            this._blood = new PIXI.Sprite(Serial.assetLoader.getTextures("wincap/Blood_asset_wincap")[0]);
            this._blood.anchor.set(0.5);
            this._blood.position.set(360, 570);
            this.addChild(this._blood);
            this._selection = new PIXI.Text("50/50\n+18700X/+0x", this._selectionStyle);
            this._selection.anchor.set(0.5);
            this._selection.position.set(360, 580);
            this.addChild(this._selection);
        }
        this._blood!.visible = true;
        this._selection.visible = true;
    }

    public hideSelection():void {
        if(this._blood) {
            this._blood.visible = false;
        }
        if(this._selection) {
            this._selection.visible = false;
        }
    }
}